module.exports = __webpack_public_path__ + "static/media/ic_gmail.67e95ac2.svg";